import { render, staticRenderFns } from "./LaudosDashboard.vue?vue&type=template&id=e8568f1c&scoped=true&lang=pug"
import script from "./LaudosDashboard.vue?vue&type=script&lang=js"
export * from "./LaudosDashboard.vue?vue&type=script&lang=js"
import style0 from "./LaudosDashboard.vue?vue&type=style&index=0&id=e8568f1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8568f1c",
  null
  
)

export default component.exports